<template>
  <div class="col-xl-3">
    <div class="auth-full-page-content p-md-5 p-4">
      <div class="w-100">
        <div class="d-flex flex-column h-100">
          <login-header/>
          <div class="my-auto">
            <div>
              <h5 class="text-primary">
                {{ $t('pages.forgot_password.title') }}
              </h5>

              <p class="text-muted">
                {{ $t('pages.forgot_password.subtitle') }}
              </p>

              <div class="alert alert-success mb-4"
                   role="alert"
                   v-if="!passwordSuccess && !submitted">
                {{ $t('pages.forgot_password.info') }}
              </div>

            </div>

            <div class="mt-4">

              <div class="text-center" v-if="passwordSuccess">
                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-white">
                    <i class="bx bxs-envelope h1 mb-0 text-primary"></i>
                  </div>
                </div>
                <div class="p-2 mt-4">
                  <h4>{{ $t('pages.forgot_password.success_title') }}</h4>
                  <p>
                    {{ $t('pages.forgot_password.success') }}
                  </p>
                </div>
              </div>

              <b-alert
                  v-model="isResetError"
                  class="mb-4"
                  variant="danger"
                  dismissible>
                {{ error }}
              </b-alert>

              <form @submit.prevent="tryToReset" v-if="!passwordSuccess">
                <div class="mb-3">
                  <label for="email">{{ $t('pages.forgot_password.email') }}</label>
                  <input
                      type="email"
                      v-model="email"
                      class="form-control"
                      id="email"
                      :placeholder="$t('pages.forgot_password.email_placeholder')"
                      :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div
                      v-if="submitted && $v.email.$error"
                      class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">
                      {{ $t('pages.forgot_password.validations.email_required') }}
                    </span>
                    <span v-if="!$v.email.email">
                      {{ $t('pages.forgot_password.validations.email_invalid') }}
                    </span>
                  </div>
                </div>
                <div class="mb-3 row mb-0">
                  <div class="col-12 text-end">
                    <b-button variant="primary" class="btn btn-primary w-md" type="submit" :disabled="loading">
                      <b-spinner v-if="loading" small/>
                      {{ $t('pages.forgot_password.reset_password') }}
                    </b-button>
                  </div>
                </div>
              </form>

              <div class="mt-5 text-center">
                <p>
                  {{ $t('pages.forgot_password.remember') }}
                  <router-link
                      to="/login"
                      class="fw-medium text-primary"
                  >
                    {{ $t('pages.forgot_password.sign') }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <login-footer/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import LoginHeader from "./LoginHeader";
import LoginFooter from "./LoginFooter";
import AuthService from "../../../../Services/Api/AuthService";

export default {
  components: {
    LoginFooter,
    LoginHeader,
  },
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      passwordSuccess: false,
      loading:false
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    async tryToReset() {

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return
      } else {
        this.tryingToReset = true;
        this.isResetError = null;
        this.loading = true
        const vm = this

        AuthService.forgotPassword({
          payload: {
            email: vm.email
          }
        }).then(function () {
          vm.passwordSuccess = true
          vm.tryingToReset = false;
          vm.isResetError = false;
        }).catch(err => {
          vm.tryingToReset = false;
          vm.error = err.data.message ? err.data.message : "";
          vm.isResetError = true;
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
}
</script>
